var React = require('react');

function InvoicesIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#131416","fillRule":"evenodd","d":"M2 1h20v23l-2.5-1-2.5 1-2.5-1-2.5 1-2.5-1L7 24l-2.5-1L2 24V1Zm18 2H4v18.046l.5-.2 2.5 1 2.5-1 2.5 1 2.5-1 2.5 1 2.5-1 .5.2V3Zm-9 13.919c-1.299-.198-2.28-.738-3-1.458l1.132-1.61a4.255 4.255 0 0 0 3.079 1.32c1.146 0 1.684-.508 1.684-1.074 0-.681-.913-.894-2-1.148-1.6-.373-3.576-.834-3.576-3.003 0-1.361.996-2.526 2.681-2.854V5h2v2.071c1.095.162 2.027.594 2.768 1.279L14.62 9.888c-.784-.725-1.83-1.06-2.817-1.06-.871 0-1.365.378-1.365.959 0 .6.862.804 1.907 1.051 1.61.381 3.654.865 3.654 3.056 0 1.559-.99 2.78-3 3.05V19h-2v-2.081Z","clipRule":"evenodd"}));
}

InvoicesIconInline.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = InvoicesIconInline;

InvoicesIconInline.default = InvoicesIconInline;
